// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu_menu__v5eY4 .MuiList-root {
  padding: 6px;
}

.menu_menu__v5eY4 .MuiList-root > li {
  padding: 4px 8px;
}

.menu_trigger__4V9dq {
  cursor: pointer;
}

.menu_withoutSpacing__5sVOj {
  padding: 5px 5px;
}

.menu_icon__zhkb\\+ {
  margin-right: 8px;
  width: 20px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/ui/dist/menu/menu.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb","sourcesContent":[".menu :global .MuiList-root {\n  padding: 6px;\n}\n\n.menu :global .MuiList-root > li {\n  padding: 4px 8px;\n}\n\n.trigger {\n  cursor: pointer;\n}\n\n.withoutSpacing {\n  padding: 5px 5px;\n}\n\n.icon {\n  margin-right: 8px;\n  width: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu": `menu_menu__v5eY4`,
	"trigger": `menu_trigger__4V9dq`,
	"withoutSpacing": `menu_withoutSpacing__5sVOj`,
	"icon": `menu_icon__zhkb+`
};
export default ___CSS_LOADER_EXPORT___;
